var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenzeppelin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "284px",
    viewBox: "0 0 256 284",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OpenZeppelin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.999858,283.747253 L255.999858,209.886415 L175.565626,209.886415 C153.691912,209.886415 133.430089,221.368935 122.227034,240.115384 L96.1506315,283.747253 L255.999858,283.747253 Z",
    fill: "#63D2F9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4E5EE4",
    points: "-2.31720968e-15 -7.8343756e-15 -2.31720968e-15 73.8608385 211.856833 73.8608385 256 -7.8343756e-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.392437,115.433222 L0.233266484,283.747396 L86.4184938,283.747396 L207.38681,82.3833378 L159.794943,82.3833378 C135.856658,82.3833378 113.679261,94.9335252 101.392437,115.433222 Z",
    fill: "#63B0F9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenzeppelin);
export default __webpack_public_path__ + "static/media/openzeppelin.f78eb00874fb7b5d1c37c00b3f803200.svg";
export { ForwardRef as ReactComponent };